module.exports = {
  envName: 'cromaqa',
  dashboardUrl: 'https://dashboard.casaqa.croma.com',
  ruleServerUrl: 'https://api.casaqa.croma.com',
  turnedOffFeatures: ['journey-builder', 'flipbook-image-tagger']
};
